import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Tengo que cambiar mi personalidad?',
  a: "No, solo cambias la 'interferencia' física que impide que vean quién eres realmente."
}, {
  q: '¿Funciona si soy tímida?',
  a: 'Es ideal para tímidas, ya que el lenguaje corporal hace el trabajo pesado por ti sin que tengas que decir una palabra.'
}, {
  q: '¿Qué pasa si tengo más de 40 años?',
  a: 'El magnetismo de élite no tiene edad; se basa en la elegancia y la calma, cualidades que se valoran más con la madurez.'
}, {
  q: '¿Es un libro muy largo?',
  a: 'Es una guía directa al grano, diseñada para leerse en una tarde y aplicarse esa misma noche.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-darker" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-32">
          <h2 className="font-serif text-3xl md:text-4xl text-cream" data-id="element-33">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-px bg-gold mx-auto mt-6 opacity-50" data-id="element-34"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="border border-gold/10 rounded-sm overflow-hidden bg-dark" data-id="element-36">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-37">
                <span className="font-serif text-lg text-cream" data-id="element-38">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-39" />
              </button>
              <AnimatePresence data-id="element-40">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-41">
                    <div className="p-6 pt-0 font-sans text-cream/70 font-light leading-relaxed border-t border-gold/5 mx-6" data-id="element-42">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}